// extracted by mini-css-extract-plugin
export default {"resultsHeaderTitle":"NVDQkm","mobileHeadingGap":"_4e6l9","mobileEmptyQueryGap":"YfJKdw"};